import React, { ReactNode } from 'react';
import { Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { BuyProcessFormUserTip } from '../../../buy-process-form/components/user-tip/user-tip';
import { Arrow } from '../../../../assets/icons/arrow';

interface FormSectionInfoProps {
  title: string;
  size?: 'normal' | 'small';
  children: ReactNode | ReactNode[];
}

const useStyles = makeStyles((theme) => ({
  alert: {
    position: 'relative',
    marginTop: '8px',
  },
  alertArrow: {
    position: 'absolute',
    bottom: '-18px',
    borderColor: 'rgb(237, 247, 237)',
    color: 'rgb(237, 247, 237)',
    fill: 'rgb(237, 247, 237)',
  },
  infoBoxGutter: {
    marginBottom: theme.spacing(3),
  },
}));

type FormSectionInfoComponent = React.FC<FormSectionInfoProps> & {
  InfoBox: (props: InfoBoxProps) => JSX.Element;
  InfoBoxTitled: (props: InfoBoxTitledProps) => JSX.Element;
};

export const FormSectionInfo: FormSectionInfoComponent = (props) => (
  <React.Fragment>{props.children}</React.Fragment>
);

interface InfoBoxProps {
  children?: ReactNode | ReactNode[];
  gutterBottom?: boolean;
  hasArrow?: boolean;
  style?: React.CSSProperties;
}

const InfoBox = ({
  children,
  hasArrow = true,
  gutterBottom = true,
  style,
}: InfoBoxProps) => {
  const classes = useStyles();
  const infoBoxClasses = classNames(classes.alert, {
    [classes.infoBoxGutter]: gutterBottom,
  });

  return (
    <BuyProcessFormUserTip>
      <Alert
        style={style}
        className={infoBoxClasses}
        severity="success"
        variant="standard"
      >
        {hasArrow && <Arrow className={classes.alertArrow} />}

        {children}
      </Alert>
    </BuyProcessFormUserTip>
  );
};

type InfoBoxTitledProps = InfoBoxProps & {
  title: string;
  className?: string;
  titleVariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

FormSectionInfo.InfoBox = InfoBox;
FormSectionInfo.InfoBoxTitled = function InfoBoxTitled({
  titleVariant = 'h5',
  ...props
}: InfoBoxTitledProps) {
  const { title, ...rest } = props;

  return (
    <div className={props.className}>
      <Typography
        style={{
          color: 'rgb(90, 90, 90)',
          fontWeight: 800,
          fontFamily: 'Editor',
          marginBottom: '8px',
        }}
        variant={titleVariant}
      >
        {title}
      </Typography>

      {props.children && <InfoBox {...rest}>{props.children}</InfoBox>}
    </div>
  );
};
